<!--
Usage:
<dropdown title="New Edit1" :link="{name: 'description', params: {id: 'all'}}">
    <li><a href="/programs/all/edit/description">Edit</a></li>
    <li><a href="/programs/all/registrations">Registrations</a></li>
</dropdown>
-->

<template>
    <div class="main">
        <span class="dropdown-buttons" ref="main" v-if="link">
            <router-link :to="link" class="button primary-action">{{title}}</router-link><a ref="down" class="button dropdown dropdown-trigger secondary" @click="open=!open"></a>
        </span>

        <span ref="main" v-else-if="single_button" >
            <a class="button success" @click="open=!open" ref="down">{{title}}</a>
        </span>

        <span class="dropdown-buttons" ref="main" v-else-if="open_on_main_click">
            <a class="button primary-action" @click="open=!open" ref="primary">{{title}}</a><a ref="down" class="button dropdown dropdown-trigger secondary" @click="open=!open"></a>
        </span>

        <span class="dropdown-buttons" ref="main" v-else>
            <a class="button primary-action" @click="$emit('main-click')">{{title}}</a><a ref="down" class="button dropdown dropdown-trigger secondary" @click="open=!open"></a>
        </span>
        <ul ref="menu" class="f-dropdown" :class="[{hidden: !open}, text_align]" :style="{top:top + 'px',left:left+'px'}">
            <slot />
        </ul>
    </div>
</template>
<script>
export default{
  props: {
    title: String,
    link: [String, Object],
    single_button: {
      type: Boolean,
      default: false
    },
    text_align: {
      type: String,
      default: 'right',
    },
    open_on_main_click: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      open: false,
      left: 0,
      top: 0
    }
  },
  watch: {
    open(){ this.setPosition() }
  },
  mounted(){
    window.addEventListener("click", this.close)
    window.addEventListener("scroll", this.setPosition)
    window.addEventListener("resize", this.setPosition)

    this._scroll = this.$el.closest("[data-doublescroll]")
    if (this._scroll) this._scroll.addEventListener("scroll", this.setPosition)
  },
  destroyed() {
    window.removeEventListener("click", this.close)
    window.removeEventListener("scroll", this.setPosition)
    window.removeEventListener("resize", this.setPosition)

    if (this._scroll) this._scroll.removeEventListener("scroll", this.setPosition)
  },
  methods:{
    close(e){
      if (e.target === this.$refs.down || e.target === this.$refs.primary) return;
      if (!this.open) return;
      this.open = false
    },
    setPosition(){
      if (this.open){
        this.left = this.$refs.main.getBoundingClientRect().left - 20
        this.top = this.$refs.main.getBoundingClientRect().top + this.$refs.main.clientHeight
      }
    },
  }
}
</script>
<style scoped>
    .dropdown-trigger{
      min-width: 0 !important;
    }
    .f-dropdown{
        position: fixed;
        /*top:auto;*/
    }
    .main{
        /*position: relative;*/
        display: inline-block;
    }
    /*.success{*/
    /*  background-color: #476da7;*/
    /*  border: 0 !important;*/
    /*  border-radius: 4px !important;*/
    /*  box-shadow: 0 2px 8px #476da7;*/
    /*  color: #fff;*/
    /*  cursor: pointer;*/
    /*  font-size: 0.9rem;*/
    /*  font-weight: 600;*/
    /*  overflow-wrap: break-word;*/
    /*  padding: 0.6rem 0.8rem;*/
    /*  min-height: 32px;*/
    /*  text-align: center;*/
    /*}*/
    .button{
      height: 36px !important;
      margin-bottom: 0;
    }

</style>
